import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueClickAway from "vue3-click-away"

import App from '~/vue/apps/Jobs.vue'

// Main app
const main = async () => {
    const pinia = createPinia()
    const app = createApp(App)

    app.use(pinia)
    app.use(VueClickAway)
    
    return app.mount('#vue-jobs-cta')
}

// Execute async function
main().then(() => {
    console.log()
})

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}